import { getMetaValue } from './browser.js';
export function getSiteVersion(): '2.0' | '3.0' {
  const siteVersion = getMetaValue('data-sfly-site-version');
  if (siteVersion === '2.0' || siteVersion === '3.0') {
    return siteVersion;
  }
  throw new Error(
    'Got unsupported site version from DOM. Value is ' + siteVersion,
  );
}

export const getPageType = () => {
  return (
    getMetaValue('page-type') ||
    getMetaValue('sfly-page-type') ||
    window?.SFLY_DTL?.page?.pageInfo?.pageType ||
    'could-not-fetch-page-type'
  );
};
